import { Menu, MenuItem } from "@mui/material";
import { useTranslations } from "next-intl";

const UserSiteSwitchMenu = ({
  anchorEl,
  open,
  onClose,
  sites,
  currentSiteId,
  onSelectSite,
  isLoading,
}) => {
  const t = useTranslations("usermenu");

  return (
    <Menu
      id="site-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      MenuListProps={{
        dense: true,
        sx: {
          py: 0.25,
          "& .MuiMenuItem-root": {
            minHeight: 36,
            py: 0.75,
            px: 1,
            fontSize: "0.9rem",
          },
        },
      }}
    >
      <MenuItem disabled>{t("siteSwitch")}</MenuItem>
      {isLoading && <MenuItem disabled>...</MenuItem>}
      {!isLoading &&
        sites.map((site) => (
          <MenuItem
            key={site.id}
            selected={site.id === currentSiteId}
            onClick={() => onSelectSite?.(site.id)}
          >
            {site.name}
          </MenuItem>
        ))}
    </Menu>
  );
};

export default UserSiteSwitchMenu;
